import UseTableSort from './UseTableSort'

export default UseTableSort
